/**
 * Кнопки ряда над сообщением — по правилу веб-клиента Discord (его
 * `message-actions`): не все действия сразу, а те, что нужны этому сообщению.
 *
 * - Своё, которое можно править, — «Изменить» вместо «Ответить»: себе
 *   отвечают редко, а правят часто. Ответ себе — с Shift.
 * - «Переслать» стоит почти всегда, и место ветки — за Shift. Ветка в ряду
 *   видна, только когда она уже есть («Показать ветку») или переслать нельзя.
 * - С Shift ряд раскрывается: быстрых реакций нет, спереди копирование
 *   ссылки, «непрочитанное», закладка, закрепление, ветка и ответ себе, а
 *   «Удалить» встаёт на место «Ещё» и удаляет без вопроса.
 */
export type BarAction =
  | "copy-link"
  | "mark-unread"
  | "save"
  | "pin"
  | "thread"
  | "reply"
  | "react"
  | "edit"
  | "forward"
  | "view-thread"
  | "publish"
  | "delete"
  | "more";

export function messageBar({
  expanded,
  canReact,
  canSend,
  editable,
  forwardable,
  canThread,
  hasThread,
  canPin,
  canSave,
  canMarkUnread,
  canDelete,
  canPublish,
}: {
  /** Shift зажат, а панель знаков не открыта. */
  expanded: boolean;
  canReact: boolean;
  /** Можно писать: без этого нет ни ответа, ни новой ветки. */
  canSend: boolean;
  /** Своё и правится. */
  editable: boolean;
  forwardable: boolean;
  /** Ветки в этом канале заводить можно. */
  canThread: boolean;
  /** У сообщения уже есть ветка. */
  hasThread: boolean;
  canPin: boolean;
  canSave: boolean;
  canMarkUnread: boolean;
  canDelete: boolean;
  canPublish: boolean;
}): { quick: boolean; actions: BarAction[] } {
  const startThread = canSend && canThread && !hasThread;
  const actions: BarAction[] = [];

  if (expanded) {
    actions.push("copy-link");
    if (canMarkUnread) actions.push("mark-unread");
    if (canSave) actions.push("save");
    if (canPin) actions.push("pin");
    if (startThread && forwardable) actions.push("thread");
    if (canSend && editable) actions.push("reply");
  }
  if (canReact) actions.push("react");
  if (canSend && !editable) actions.push("reply");
  if (editable) actions.push("edit");
  if (forwardable) actions.push("forward");
  if (startThread && !forwardable) actions.push("thread");
  if (hasThread) actions.push("view-thread");
  if (canPublish) actions.push("publish");
  actions.push(expanded && canDelete ? "delete" : "more");

  return { quick: canReact && !expanded, actions };
}
